import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link, useNavigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import LogsPage from './components/LogsPage';
import BotControlPage from './components/BotControlPage';

function Navbar({ onLogout }) {
  return (
    <nav className="bg-gray-800 text-white p-4 flex justify-between">
      <div className="space-x-4">
        <Link to="/logs" className="hover:underline">Logs</Link>
        <Link to="/bots" className="hover:underline">Bot control</Link>
      </div>
      <button
        onClick={onLogout}
        className="bg-red-600 px-3 py-1 rounded hover:bg-red-700"
      >
        Logout
      </button>
    </nav>
  );
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));

  // Чтобы синхронизироваться с localStorage, если токен где-то меняется
  useEffect(() => {
    function handleStorageChange() {
      setIsAuthenticated(!!localStorage.getItem('token'));
    }
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    navigate('/login');
  };

  return (
    <>
      {isAuthenticated && <Navbar onLogout={handleLogout} />}
      <Routes>
        <Route path="/login" element={<LoginPage onLogin={() => setIsAuthenticated(true)} />} />
        <Route
          path="/logs"
          element={
            isAuthenticated ? <LogsPage /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/bots"
          element={
            isAuthenticated ? <BotControlPage /> : <Navigate to="/login" />
          }
        />
        <Route
          path="*"
          element={<Navigate to={isAuthenticated ? "/logs" : "/login"} />}
        />
      </Routes>
    </>
  );
}

export default function RootApp() {
  return (
    <Router>
      <App />
    </Router>
  );
}
